// PointurePlus.jsx
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card, Empty, Space, Tag } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
// Pont jetons CSS → canvas : le graphique lit la charte au lieu de figer des
// couleurs. Le jour où la charte bascule, il suit sans être retouché.
import { jetons, optionsBase, fusionner } from '../../../../components/ndoe/chartTheme';
import "./pointurePlus.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip
);

const PointurePlus = ({ pointures = [] }) => {
  console.log('Pointure', pointures);
  
  // ✅ Vérifier que pointures est bien un tableau
  const dataPointures = Array.isArray(pointures) ? pointures : [];

  // Extraire les labels et les données
  const labels = dataPointures.map(item => item.pointure?.toString() || 'N/A');
  const values = dataPointures.map(item => item.total_sorties || 0);

  // ✅ Si pas de données, afficher un message
  if (dataPointures.length === 0) {
    return (
      <Card 
        className="pointurePlus"
        bordered={false}
        title={
          <Space>
            {/* Hors canvas : le CSS s'applique, on passe donc le jeton directement. */}
            <BarChartOutlined style={{ fontSize: 18, color: 'var(--ndoe-ink)' }} />
            <span style={{ fontSize: 15, fontWeight: 600 }}>Pointures les plus demandées</span>
          </Space>
        }
        extra={
          <Tag color="default">Sorties sur 30 jours</Tag>
        }
      >
        <Empty 
          description="Aucune donnée de pointure disponible"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '30px 0' }}
        />
      </Card>
    );
  }

  // Jetons lus DANS le rendu : au chargement du module le CSS n'est pas garanti
  // appliqué, getComputedStyle rendrait du vide et le pont retomberait en
  // silence sur ses valeurs de repli.
  const t = jetons();

  // Série unique, non sémantique (un volume de sorties par pointure) : une seule
  // couleur de la charte, pas la palette catégorielle — colorier chaque barre
  // différemment laisserait croire à une distinction de nature entre pointures.
  const data = {
    labels: labels,
    datasets: [
      {
        data: values,
        backgroundColor: t.royal,
        hoverBackgroundColor: t.gold,
        borderRadius: 6,
        borderSkipped: false,
        barThickness: 40,
      },
    ],
  };

  // optionsBase apporte l'info-bulle aux couleurs de la charte et une animation
  // sobre (coupée si l'utilisateur a demandé moins de mouvement au niveau
  // système). L'axe Y reste masqué : la valeur est déjà dans l'info-bulle.
  const options = fusionner(optionsBase(), {
    interaction: { mode: 'nearest', intersect: true },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function(context) {
            return `${context.parsed.y} sorties`;
          }
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        display: false,
      },
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          color: t.text,
          font: {
            size: 14,
            weight: "500",
          },
        },
      },
    },
  });

  return (
    <Card 
      className="pointurePlus"
      bordered={false}
      title={
        <Space>
          <BarChartOutlined style={{ fontSize: 18, color: 'var(--ndoe-ink)' }} />
          <span style={{ fontSize: 15, fontWeight: 600 }}>Pointures les plus demandées</span>
        </Space>
      }
      extra={
        <Tag color="default">Sorties sur 30 jours</Tag>
      }
    >
      <div className="pointurePlus_chart">
        <Bar data={data} options={options} />
      </div>
    </Card>
  );
};

export default PointurePlus;